import styled from 'styled-components'
import { Flex } from '@rebass/grid'

export const Wrapper = styled(Flex)`
  width: 32px;
  height: 32px;
`
